import { QueryClient } from '@tanstack/react-query';
import { getErrorMessage } from './errorHandler';
import { normalizeApiError, UNKNOWN_ERROR_CODE } from '../types/api-errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      retry: (failureCount, error: unknown) => {
        // AB#1919 (WS-5b) — read the HTTP status through the normalizer, which
        // prefers the RFC 7807 `status` member and falls back to the axios
        // response status / legacy `statusCode`. (The previous raw
        // `error.status` read was effectively always undefined for axios
        // errors, so 401/403 slipped through the no-retry guard.)
        const { status } = normalizeApiError(error);
        return failureCount < 2 && status !== 401 && status !== 403;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error: unknown) => {
        // AB#1919 (WS-5b) — single normalizer: `code` via `errorCode ?? code`,
        // human text via `detail ?? message`.
        const appError = normalizeApiError(error);
        const msg =
          appError.code !== UNKNOWN_ERROR_CODE
            ? getErrorMessage(appError.code)
            : (appError.detail || getErrorMessage(null));
        console.error('Mutation error:', msg);
      },
    },
  },
});
